var _styled;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BLACK, YELLOW } from 'govuk-colours';
import { withWhiteSpace } from '@govuk-react/hoc';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
var Anchor = styled('a')((_styled = {
  fontFamily: NTA_LIGHT,
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  fontWeight: 400,
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled.display = 'inline-block', _styled.position = 'relative', _styled.marginTop = '15px', _styled.paddingLeft = '14px', _styled.border = 0, _styled.backgroundColor = 'transparent', _styled.color = "" + BLACK, _styled.borderBottom = "1px solid " + BLACK, _styled.textDecoration = 'none', _styled['::before'] = {
  display: 'block',
  width: 0,
  height: 0,
  borderStyle: 'solid',
  borderColor: 'transparent',
  clipPath: 'polygon(0% 50%, 100% 100%, 100% 0%)',
  borderWidth: '5px 6px 5px 0',
  borderRightColor: "" + BLACK,
  content: "''",
  position: 'absolute',
  top: '-1px',
  bottom: '1px',
  left: 0,
  margin: 'auto'
}, _styled[':focus'] = {
  backgroundColor: "" + YELLOW,
  outline: "3px solid " + YELLOW
}, _styled));
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * <BackLink>Back</BackLink>
 * ```
 *
 * With custom click handler
 * ```jsx
 * <BackLink onClick={this.myCustomFunction}>Back</BackLink>
 * ```
 *
 * With `href` attribute
 * ```jsx
 * <BackLink href='#'>Back</BackLink>
 * ```
 *
 * ### References:
 * - https://github.com/alphagov/govuk-frontend/tree/master/src/components/back-link
 *
 */

var BackLink = function BackLink(_ref) {
  var onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["onClick"]);

  return React.createElement(Anchor, _extends({
    onClick: onClick
  }, props));
};

BackLink.defaultProps = {
  children: 'Back',
  onClick: undefined
};
export default withWhiteSpace({
  marginBottom: 3
})(BackLink);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/back-link/es/index.js
// module id = 135
// module chunks = 0